import { useEffect, useState } from "react";

// Minimal history router — "/" (Spot) and "/collections" ("/lifelist" still
// resolves there for old links). The Worker's SPA asset fallback serves
// index.html for deep links, so reading location.pathname on load is enough.

export function useRoute(): string {
  const [path, setPath] = useState(
    typeof window === "undefined" ? "/" : window.location.pathname,
  );

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPop);
    window.addEventListener("ff:navigate", onPop);
    return () => {
      window.removeEventListener("popstate", onPop);
      window.removeEventListener("ff:navigate", onPop);
    };
  }, []);

  return path;
}

export function navigate(to: string): void {
  if (window.location.pathname === to) return;
  window.history.pushState({}, "", to);
  window.dispatchEvent(new Event("ff:navigate"));
}
